module.exports = __webpack_public_path__ + "img/facebook.ae297d79.svg";